import Axios from "../../src/helpers/axios";

export const getAllCurrencies = () => {
  return Axios.get("/api/ecommerce/v1/currencies");
};

export const getFilterPrice = (currencyId) => {
  return Axios.get(`/api/ecommerce/v1/currencies/price/filter?currency_id=${currencyId}`)
}